let isProd = true;

const server = isProd ? "https://vconnect-di4e.onrender.com" : "http://localhost:3000"

export default server;